import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import "../styles/home.css";
import Navbar from "../components/Navbar";
import BottomNav from "../components/BottomNav";
import { useCart } from "../contexts/CartContext";
import axios from "axios";
import visaLogo from "../images/visa.png";
import upiLogo from "../images/upi.png";
import gpayLogo from "../images/gpay.png";
import paytmLogo from "../images/paytm.png";
import phonepeLogo from "../images/phonepe.png";


const ProductDetails = () => {

  const { id } = useParams();
  const navigate = useNavigate();
  const { addToCart } = useCart();

  const [product, setProduct] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showFullscreen, setShowFullscreen] = useState(false);
  const [zoom, setZoom] = useState(1);

  /* FETCH PRODUCT */
  useEffect(() => {
    axios
      .get(`https://ecommerce-backend-zxtw.onrender.com/api/products/${id}`)
      .then((res) => {
        setProduct(res.data);
        setCurrentIndex(0);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [id]);

  /* LOADING STATE */
  if (!product) {
    return (
      <div>
        <Navbar />
        <h2 style={{ textAlign: "center", marginTop: "100px" }}>
          Loading...
        </h2>
      </div>
    );
  }

  /* IMAGE SLIDER */
  const handleNext = () => {
    setCurrentIndex((prev) =>
      prev === product.images?.length - 1 ? 0 : prev + 1
    );
  };

  const handlePrev = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? product.images?.length - 1 : prev - 1
    );
  };

  /* IMAGE ZOOM */
  const handleZoom = (e) => {
    e.preventDefault();

    if (e.deltaY < 0) {
      setZoom((prev) => Math.min(prev + 0.2, 3));
    } else {
      setZoom((prev) => Math.max(prev - 0.2, 1));
    }
  };

  return (
    <div className="product-details-container">

      <Navbar />
      {/* BACK BUTTON */}
      <div className="back-button-container">
        <button className="back-btn" onClick={() => navigate(-1)}>
          ⬅
        </button>
      </div>

      <div className="details-content">

        {/* IMAGE SECTION */}
        <div className="image-section">

          <div className="image-slider">

            {product.images?.length > 1 && (
              <button className="arrow left" onClick={handlePrev}>
                ‹
              </button>
            )}

            <div className="image-wrapper">
              <img
                src={
                  product.images?.[currentIndex] ||
                  "https://via.placeholder.com/500"
                }
                alt={product.name}
                className="main-image"
                onClick={() => {
                  setShowFullscreen(true);
                  setZoom(1);
                }}
              />
            </div>

            {product.images?.length > 1 && (
              <button className="arrow right" onClick={handleNext}>
                ›
              </button>
            )}

          </div>

          {/* THUMBNAILS */}
          <div className="thumbnail-container">
            {product.images?.map((img, index) => (
              <img
                key={index}
                src={img}
                alt="thumb"
                className={`thumbnail ${
                  index === currentIndex ? "active-thumb" : ""
                }`}
                onClick={() => setCurrentIndex(index)}
              />
            ))}
          </div>

        </div>

        {/* PRODUCT INFO */}
        <div className="info-section">

          {/* BRAND */}
          <p className="product-category">
            {product.category}
          </p>

          {/* PRODUCT NAME */}
          <h2>{product.name}</h2>

          {/* PRICE */}
          <p className="price">₹{product.price}</p>

          {/* DESCRIPTION */}
          <p>
            {product.description || "High quality premium product."}
          </p>

          {/* DELIVERY INFO */}
          <div className="product-extra-info">

            <p>
              <strong>Delivery:</strong>{" "}
              {product.deliveryDuration || "5-7 Days"}
            </p>

            <p>
              <strong>Packing:</strong>{" "}
              {product.packingMethod || "Secure Packaging"}
            </p>

            <p>
              <strong>Shipping:</strong>{" "}
              {product.shippingFee || "Free Shipping"}
            </p>

          </div>

          {/* ADD TO CART */}
          <button
            className="add-cart-btn"
            onClick={() => {
              addToCart(product);
              navigate("/cart");
            }}
          >
            Add to Cart
          </button>

        </div>

        <p className="payment-title">Secure Payments</p>

          <div className="payment-badges neon">
            <img src={visaLogo} alt="Visa" />
            <img src={upiLogo} alt="UPI" />
            <img src={gpayLogo} alt="Google Pay" />
            <img src={paytmLogo} alt="Paytm" />
            <img src={phonepeLogo} alt="PhonePe" />
          </div>

      </div>
      

      {/* FULLSCREEN IMAGE VIEWER */}
      {showFullscreen && (
        <div
          className="fullscreen-viewer"
          onWheel={handleZoom}
        >

          <button
            className="close-btn"
            onClick={() => setShowFullscreen(false)}
          >
            ✕
          </button>

          <img
            src={product.images?.[currentIndex]}
            alt="zoom"
            className="fullscreen-image"
            style={{
              transform: `scale(${zoom})`,
              transition: "0.2s"
            }}
          />

        </div>
      )}

      <BottomNav />

    </div>
  );
};

export default ProductDetails;